import { tv } from 'tailwind-variants'

export const messagesVariants = tv({
  slots: {
    container: 'flex flex-col h-full',
    header: 'w-full justify-center items-center absolute bg-white',
    loading: 'flex justify-center my-mili',
    containerTag: 'flex justify-center items-center my-mili',
    tag: 'text-sub bg-secondary-xlight text-secondary-xdark',
    loadingChat: 'flex flex-1 justify-center items-center w-full',
    list: 'flex-1 bg-white relative overflow-y-auto',
    sendMessage: 'min-h-[4rem] mb-deca'
  }
})
